import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=42287469&scoped=true"
var script = {}
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=42287469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42287469",
  null
  
)

export default component.exports